export const queryPage ='123'
export const batchUpdateOrDelete ='1231'
export const updateSortNum ='123111111'
export const saveOrUpdate ='1231'
export const Download ='1231'